import CommonConstanst from '@/common/CommonConstants'
import SessionStorageService from '@/common/SessionStorageService'
import ExtInfoRequestModel from '@/api/data/ExtInfo/ExtInfoRequestModel'
import ExtInfoResponseModel from '@/api/data/ExtInfo/ExtInfoResponseModel'
import CommonUtil from '@/common/utils/CommonUtil'
import ValidateUtil from '@/common/utils/ValidationUtil'
import RestService from '@/common/RestService'
import { CABA1020ResponseModel } from '@/api/data/CAB/CABA1020/CABA1020ResponseModel'
import ApiUrlConstants from '@/common/ApiUrlConstants'
import Moment from 'moment'
import { CABA1020RequestModel } from '@/api/data/CAB/CABA1020/CABA1020RequestModel'
import { FormatConstants } from '@/common/FormatConstants'
import CABG1020ViewModel from './CABG1020ViewModel'
import { isEmpty } from 'xe-utils'

export default class CABG1020Service {
  /**
   * 掛金は国民年金連合会により、通常毎月26日に引き落とされます<br>※金融機関が休業日の場合、翌営業日
   */
  private NXT_CONTR_DAY =
    '当月分の掛金は、国民年金基金連合会により翌月26日に引き落とされます。<br />26日が引落金融機関の休業日の場合は、翌営業日となります。'

  /**
   * 次回拠出日は--です
   */
  private NXT_CONTR_DAY_NULL = '次回拠出日は<b> -- </b>です'
  private JOINER_ACC_LENGTH = 10

  /**
   * CABA1020 API処理呼出
   * @returns caba1020ResponseModel
   */
  public async callAPICABA1020(): Promise<CABA1020ResponseModel> {
    const caba1020RequestModel = new CABA1020RequestModel()
    const caba1020ResponseModel: CABA1020ResponseModel = <
      CABA1020ResponseModel
    > await RestService.post(ApiUrlConstants.CABA1020, caba1020RequestModel)
    return caba1020ResponseModel
  }

  /**
   * データ処理
   * @param cabg1020ViewModel
   * @returns cabg1020ViewModel
   */
  public setDisplayTextLabel(cabg1020ViewModel): CABG1020ViewModel {
    if (cabg1020ViewModel.monthlyPrem.cntctUnitDiv === '1') {
      if (isEmpty(cabg1020ViewModel.monthlyPrem.nxtContrDay?.trim())) {
        cabg1020ViewModel.nxtContrDayTxt = this.NXT_CONTR_DAY_NULL
      } else {
        const nxtContrDay = Moment(
          cabg1020ViewModel.monthlyPrem.nxtContrDay
        ).format(FormatConstants.DATE_FULL)
        cabg1020ViewModel.nxtContrDayTxt = `次回拠出日は<b>${nxtContrDay}</b>です`
      }
    } else if (cabg1020ViewModel.monthlyPrem.cntctUnitDiv === '2') {
      cabg1020ViewModel.nxtContrDayTxt = this.NXT_CONTR_DAY
    } else {
      cabg1020ViewModel.nxtContrDayTxt = this.NXT_CONTR_DAY_NULL
    }

    return cabg1020ViewModel
  }

  /**
   * チャートデータ処理
   * @param cabg1020ViewModel
   * @returns cabg1020ViewModel
   */
  public fomatDataChart(cabg1020ViewModel): CABG1020ViewModel {
    const totalMap = new Map()
    cabg1020ViewModel.premDistAssignSts.productInfoLst.forEach((item) => {
      let total = 0
      if (totalMap.has(item?.assetDiv)) {
        total = totalMap.get(item?.assetDiv).total
      }
      const data = {
        name: item.assetDivName,
        total: total + item.distRatio,
        color: item.assetColor
      }
      return totalMap.set(item.assetDiv, data)
    })

    totalMap.forEach((item) => {
      if (item.total !== 0) {
        const data = {
          color: item.color,
          y: item.total,
          name: item.name
        }
        cabg1020ViewModel.dataContrAlloDesignStt.push(data)
      }
    })

    cabg1020ViewModel.dataContrAlloDesignStt.sort((a, b) => {
      return b.y - a.y
    })

    return cabg1020ViewModel
  }

  /**
   * ExtInfo API処理呼出
   * @returns Object
   */
  public async callAPIExtInfo(): Promise<ExtInfoResponseModel> {
    const extInfoRequestModel: ExtInfoRequestModel = new ExtInfoRequestModel()
    const extInfoResponseModel: ExtInfoResponseModel = <ExtInfoResponseModel>(
      await RestService.post(ApiUrlConstants.EXT_INFO, extInfoRequestModel)
    )
    return extInfoResponseModel
  }

  /**
   * ログインボタン押下
   * @param cabg1020ViewModel
   * @returns
   */
  public validationLoginSSO(cabg1020ViewModel: CABG1020ViewModel): Array<any> {
    const errorValid = []
    while (true) {
      if (
        ValidateUtil.isNotEmptyValid(
          cabg1020ViewModel.formLogin.joinerAccNo
        ) === false
      ) {
        errorValid.push({
          code: 'MSGCABG1020WF002',
          message: CommonUtil.getMessage('MSGCABG1020WF002', [])
        })
        break
      }

      if (
        ValidateUtil.isHankakuNumValid(
          cabg1020ViewModel.formLogin.joinerAccNo
        ) === false
      ) {
        errorValid.push({
          code: 'MSGCABG1020WF003',
          message: CommonUtil.getMessage('MSGCABG1020WF003', [])
        })
        break
      }

      if (
        ValidateUtil.isLengthValid(
          this.JOINER_ACC_LENGTH,
          cabg1020ViewModel.formLogin.joinerAccNo
        ) === false
      ) {
        errorValid.push({
          code: 'MSGCABG1020WF004',
          message: CommonUtil.getMessage('MSGCABG1020WF004', [])
        })
        break
      }

      const sesJoinerAccNo = JSON.parse(
        SessionStorageService.getItem(CommonConstanst.USER_INFO)
      ).userInfo.joinerAccNo
      if (cabg1020ViewModel.formLogin.joinerAccNo !== sesJoinerAccNo) {
        errorValid.push({
          code: 'MSGCABG1020WF005',
          message: CommonUtil.getMessage('MSGCABG1020WF005', [])
        })
        break
      }

      if (
        ValidateUtil.isNotEmptyValid(cabg1020ViewModel.formLogin.password) ===
        false
      ) {
        errorValid.push({
          code: 'MSGCABG1020WF006',
          message: CommonUtil.getMessage('MSGCABG1020WF006', [])
        })
        break
      }

      if (
        ValidateUtil.isHankakuValid(cabg1020ViewModel.formLogin.password) ===
        false
      ) {
        errorValid.push({
          code: 'MSGCABG1020WF007',
          message: CommonUtil.getMessage('MSGCABG1020WF007', [])
        })
        break
      }

      if (
        !CommonUtil.isNotEmpty(cabg1020ViewModel.baseUrl) ||
        !CommonUtil.isNotEmpty(cabg1020ViewModel.clientID)
      ) {
        errorValid.push({
          code: 'MSGCABG1020WF008',
          message: CommonUtil.getMessage('MSGCABG1020WF008', [])
        })
        break
      }
      if (errorValid.length === 0) {
        break
      }
    }
    return errorValid
  }
}
